import { Component, Input, OnInit } from '@angular/core';
import { ImageService } from '../../../../services/image.service';

@Component({
  selector: 'app-full-image',
  templateUrl: './full-image.component.html',
  styleUrls: ['./full-image.component.scss'],
})
export class FullImageComponent implements OnInit {
  @Input() imageUrl!: string;
  @Input() alt: string = 'image';
  @Input() width: number = 50;

  get currentWidth() {
    return this.width;
  }

  constructor(private imageService: ImageService) { }

  ngOnInit() {
  }

  showPreviewImage() {
    // this.fullscreen = !this.fullscreen;
    this.imageService.fullResumeEvent.emit(this.imageUrl);
  }
}
